import request from '@/utils/request'

/**
 * 已停机列表
 * @param {*} params token,userId
 * @returns
 */
export const Equipment = params => {
  return request({
    method: 'post',
    url: '/cm/eqp/mobileList',
    data: params
  })
}

/**
 * 已停机列表
 * @param {*} params token,userId
 * @returns
 */
export const EquipmentBeyond = params => {
  return request({
    method: 'post',
    url: '/cm/eqp/mobileOverFlowList',
    data: params
  })
}
/**
 * SIM卡列表
 * @param {*} params token,userId
 * @returns
 */
export const SimList = params => {
  return request({
    method: 'post',
    url: '/mobile/sim/list',
    data: params
  })
}

/**
 * SIM卡统计
 * @param {*} params token,userId
 * @returns
 */
export const SimStat = params => {
  return request({
    method: 'post',
    url: '/mobile/sim/stat',
    data: params
  })
}

/**
 * 充值套餐订单
 * @param {*} params token,userId
 * @returns
 */
export const saleOrder = params => {
  return request({
    method: 'post',
    url: '/mobile/sim/saleOrder',
    data: params
  })
}

/**
 * 拓展代理商
 * @param {*} params token, userId
 * @returns
 */
export const agentList = params => {
  return request({
    method: 'post',
    url: '/mobile/sim/agentList',
    data: params
  })
}

/**
 * 拓展代理商
 * @param {*} params token, userId
 * @returns
 */
export const simTransfer = params => {
  return request({
    method: 'post',
    url: '/mobile/sim/simTransfer',
    data: params
  })
}
